import { useState, useCallback, useEffect } from 'react'
import debounce from 'lodash/debounce'
import { TextField, InputAdornment, TextFieldProps } from '@mui/material'
import Iconify from '@/components/Iconify'

type Props = {
  value?: string
  onSearch?: (value: string) => void
  textFieldProps?: TextFieldProps
}

export default function ShopProductSearch(props: Props) {
  const { value, onSearch, textFieldProps } = props
  const [searchQuery, setSearchQuery] = useState(value ?? '')

  const debounceSetSearchValue = useCallback(
    debounce((_searchVal) => {
      const url = new URL(window.location.href)
      if (_searchVal) {
        url.searchParams.set('search', _searchVal)
      } else {
        url.searchParams.delete('search')
      }
      window.history.replaceState(null, '', url)
      onSearch?.(_searchVal)
    }, 650),
    []
  )

  const handleChangeSearch = async (value: string) => {
    try {
      setSearchQuery(value)
      debounceSetSearchValue(value)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (value?.toLowerCase() !== searchQuery.toLowerCase()) {
      setTimeout(() => setSearchQuery(value ?? ''), 200)
    }
  }, [value])

  return (
    <TextField
      value={searchQuery}
      onChange={(event) => handleChangeSearch(event.target.value)}
      placeholder="Search"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify
              icon={'eva:search-fill'}
              sx={{ color: 'text.disabled', width: 20, height: 20 }}
            />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment
            position="end"
            style={{ cursor: 'pointer' }}
            onClick={() => handleChangeSearch('')}
          >
            <Iconify icon={'akar-icons:cross'} />
          </InputAdornment>
        ),
      }}
      {...textFieldProps}
    />
  )
}
